<template>
  <div class="container-fluid">
    <div v-if="formation._id" class="row flex-row">
      <div class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ formation.formationName }}</h3>
            <p class="text-center">{{ formation.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات ترکیب</h4>
          </div>
          <div class="widget-body">
            <form id="formationForm" class="form-horizontal">
              <!-- formation english name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام ترکیب</label>
                <div class="col-lg-6">
                  <input type="text" name="formationName" class="form-control" :value="formation.formationName" />
                </div>
              </div>

              <!-- formationIndex -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">
                  ایندکس ترکیب در اپلیکیشن (این مورد باید با اپلیکیشن سازگار باشد، تغیرش ندهید)
                </label>
                <div class="col-lg-6">
                  <input type="number" name="formationIndex" class="form-control" :value="formation.formationIndex" />
                </div>
              </div>
              <!-- formation min level -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">سطح کاربر برای دریافت</label>
                <div class="col-lg-6">
                  <input type="number" name="minLevel" class="form-control" min="1" :value="formation.minLevel" />
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت ترکیب</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="">
                    <option value="true" :selected="formation.isAvailable">فعال</option>
                    <option value="false" :selected="!formation.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>
              <!-- is default -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">ترکیب دیفالت</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="isDefault" id="" :checked="formation.isDefault" />
                </div>
              </div>
              <!-- is reward -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">جایزه آموزش</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="isReward" id="" :checked="formation.isReward" />
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/formations">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formationService from '../../../../services/formation';
export default {
  name: 'formationdetail',
  data() {
    return {
      formation: {},
    };
  },
  created() {
    this.getformation();
  },
  methods: {
    async getformation() {
      try {
        const formation = await formationService.findformationById(this.$route.query.id);
        console.log(formation);
        this.formation = formation;
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      const form = document.getElementById('formationForm');
      const body = {
        _id: this.formation._id,
        formationName: form.formationName.value,
        formationIndex: form.formationIndex.value,
        minLevel: form.minLevel.value,
        isAvailable: form.isAvailable.value == 'true',
        isDefault: form.isDefault.checked,
        isReward: form.isReward.checked,
      };
      try {
        await formationService.updateFormation(body);
        this.getformation();
        window.notif({ isError: false, mssg: 'بروز رسانی انجام شد' });
      } catch (err) {
        console.log(err);
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
      }

      console.log(body);
    },
  },
};
</script>
